import { Component, Input } from '@angular/core';
import { Tool } from "@app/tool/model/tool.model";
import { TableConfig } from "@app/shared/util/table-config.utils";
import { Log } from "ng2-logger";
import { ToolService } from "@services/tool.service";

@Component({
    selector: 'app-tool-backups',
    templateUrl: './tool-backups.component.html',
    styleUrls: ['./tool-backups.component.scss']
})
export class ToolBackupsComponent {
    _logger = Log.create(ToolBackupsComponent.name);

    @Input() selectedTool: Tool;
    @Input() tableConfig: TableConfig = new TableConfig();

    _toolBackups: Tool[];

    constructor(private toolService: ToolService) {
    }

    onCheckedTools(backupTools: Tool[]) {
        this._logger.info('onCheckedTools:: Updating tool backups based on selections', backupTools);
        this.toolService.updateTool({
            id: this.selectedTool.id,
            backupTools: backupTools
        }).subscribe((data) => {
            this._logger.info('onCheckedTools:: API returned data', data);
        }, (error) => {
            this._logger.info('onCheckedTools:: API returned error', error);
        });
    }

    @Input()
    set toolBackups(backups) {
        this._toolBackups = backups;
        if (backups) {
            this.tableConfig.pager.count = backups.length;
        }
    }

    get toolBackups() {
        return this._toolBackups;
    }
}
